<!-- eslint-disable space-before-function-paren -->
<!-- eslint-disable vue/html-self-closing -->
<!-- eslint-disable vue/multiline-html-element-content-newline -->
<!-- eslint-disable vue/html-indent -->
<!-- eslint-disable vue/html-closing-bracket-newline -->
<!-- eslint-disable vue/first-attribute-linebreak -->
<!-- eslint-disable vue/max-attributes-per-line -->
<template>
    <section id="hero-section" class="bg-[#FFFFFF] pt-10 md:pt-14 font-roboto">
        <div
            class="container mx-auto px-2 xs:px-0 lg:px-6 grid grid-cols-1 lg:grid-cols-2 relative h-full  lg:h-[572px]">
            <div class="relative lg:hidden mt-16 flex items-center justify-end flex-col hero-mobile-images">
                <img src="/images/landing-hero-section-mobile.avif" alt="Landing Page Hero Image"
                    class="w-[148px] xs:w-[160px] sm:w-[180px] md:w-[200px] h-auto hero-main-mobile" />
                <img src="/images/landing-hero-section-right.avif" alt="Landing Page Hero Image"
                    class="w-[80px] xs:w-[100px] sm:w-[120px] md:w-[140px] h-auto absolute bottom-[30%] right-[5%] xxs:right-[10%] xs:right-[20%] sm:right-[20%] hero-right-mobile" />
                <img src="/images/landing-hero-section-left.avif" alt="Landing Page Hero Image"
                    class="w-[103px] xs:w-[120px] sm:w-[140px] md:w-[160px] h-auto right-[55%] bottom-[35%] absolute hero-left-mobile" />
            </div>
            <div
                class="flex gap-3 xs:gap-4 md:gap-5 lg:gap-6 flex-col items-center lg:items-start justify-center text-center lg:text-start mb-7 sm:mb-9 md:mb-12 lg:mb-0 hero-content">
                <h1
                    class="font-monrope text-cs-dark-900 text-xl xs:text-2xl md:text-3xl lg:text-5xl font-[800] leading-tight hero-title">
                    Sign Documents Digitally, <span class="text-cs-main-400">Faster and Safer.</span>
                </h1>
                <p class="text-[#646468] text-xs sm:text-base md:text-lg lg:text-xl font-roboto hero-subtitle">
                    Quick, secure, and ready to use anytime, anywhere ✍️
                </p>
                <button id="sign-up-action"
                    class="font-roboto w-fit text-sm bg-cs-main-500 flex items-center font-bold text-[#F2F2F3] gap-3 py-3 px-5 rounded-md hero-button"
                    @click="handleSignUp">
                    <span>
                        Sign up for free
                    </span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path
                            d="M16.0052 9.41421L7.39858 18.0208L5.98438 16.6066L14.591 8H7.00519V6H18.0052V17H16.0052V9.41421Z"
                            fill="white" />
                    </svg>
                </button>
            </div>
            <div class="relative hidden lg:block hero-desktop-images">
                <img src="/images/landing-hero-section-mobile.avif" alt="Landing Page Hero Image"
                    class="w-[300px] h-auto absolute bottom-0 right-[10%] hero-main-desktop" />
                <img src="/images/landing-hero-section-right.avif" alt="Landing Page Hero Image"
                    class="w-[160px] h-auto absolute bottom-[30%] -right-[3%] hero-right-desktop" />
                <img src="/images/landing-hero-section-left.avif" alt="Landing Page Hero Image"
                    class="w-[208px] h-auto right-[50%] xl:right-[43%] 2xl:right-[35%] bottom-[35%] absolute hero-left-desktop" />
            </div>
        </div>
    </section>

    <section id="how-work" class="bg-cs-dark-800 font-roboto">
        <div class="container mx-auto px-2 xs:px-0 lg:px-6 py-16 lg:py-24 flex flex-col gap-[30px] lg:gap-[50px]">
            <div class="flex flex-col gap-3 text-center lg:text-start work-header">
                <h2
                    class="text-cs-gray-lv-0 text-xl sm:text-2xl md:text-3xl lg:text-4xl lg:text-[40px] font-bold work-title">
                    How Izesign Works?
                </h2>
                <p class="text-cs-gray-lv-0 text-xs sm:text-sm lg:text-base text-[17px] work-subtitle">
                    A simple 4-step process to e-sign and manage documents.
                </p>
            </div>
            <div class="grid grid-cols-1 xs:grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4 lg:gap-7 work-cards">
                <div v-for="(step, index) in WORK_DATA" :key="index"
                    class="w-full px-3 py-4 lg:py-7 lg:px-5 bg-[#F9F9F9] rounded-2xl flex flex-col gap-2 sm:gap-4 relative work-card"
                    :data-index="index">
                    <img :src="step.image" :alt="`Step ${index + 1}`"
                        class="size-[40px] lg:size-[60px] relative z-10" />
                    <p class="text-cs-dark-800 font-bold text-base text-[15px] lg:text-[17px] relative z-10">
                        {{ step.title }}
                    </p>
                    <p class="text-[#646468] text-xs lg:text-base leading-tight relative z-10">
                        {{ step.description }}
                    </p>
                    <p
                        class="absolute bottom-0 text-[#F3F3F3] font-bold text-[126.88px] sm:text-[150px] md:text-[130px] lg:text-[196.706px] right-[0.5px] z-[1] work-number">
                        {{ index + 1 }}
                    </p>
                </div>
            </div>
        </div>
    </section>

    <section id="solution" class="bg-[#FFFFFF] font-roboto">
        <div
            class="container mx-auto px-2 xs:px-0 lg:px-6 py-5 sm:py-8 md:py-11 lg:pt-28 lg:pb-8 grid grid-cols-1 lg:grid-cols-2 gap-5 sm:gap-6 md:gap-7 lg:gap-[30px]">
            <div class="flex flex-col gap-3 lg:text-start text-center solution-header">
                <h3
                    class="text-xl sm:text-2xl md:text-3xl lg:text-4xl lg:text-[40px] font-monrope font-[800] text-cs-dark-900 solution-title">
                    Your Trusted <span class="text-cs-main-400">E-Signature</span> Solution
                </h3>
                <p class="text-xs md:text-sm lg:text-base lg:text-[17px] text-cs-gray-lv-3 solution-subtitle">
                    Digitize your workflow with our smart, seamless signing solution, empowering businesses to go
                    paperless and
                    effortless collaboration.
                </p>
            </div>
            <div
                class="flex items-center justify-evenly lg:justify-center flex-wrap lg:flex-nowrap lg:gap-[30px] solution-items">
                <div v-for="(step, index) in SOLUTION_DATA" :key="index"
                    class="flex flex-col items-center text-center gap-3 py-[20px] px-4 lg:px-[10px] lg:w-[152px] solution-item"
                    :data-index="index">
                    <img :src="step.image" :alt="`Step ${index + 1}`"
                        class="h-12 sm:h-16 md:h-20 lg:h-[100px] w-auto flex-shrink-0" />
                    <p class="text-base text-[15px] lg:text-[17px] text-cs-gray-lv-4 font-bold">
                        {{ step.title }}
                    </p>
                </div>
            </div>
        </div>
    </section>

    <section id="contact-us" class="bg-[#FFFFFF] font-roboto">
        <div
            class="container mx-auto px-2 xs:px-0 lg:px-6 py-[60px] lg:pt-20 lg:pb-36 grid grid-cols-1 lg:grid-cols-2 font-roboto">
            <div class="relative hidden lg:flex items-center justify-center contact-image">
                <img src="/images/landing-contact-us.avif" alt="Contact Us"
                    class="w-[80%] mx-auto h-auto contact-main-image" />
                <div class="px-3 text-cs-gray-lv-4 py-[6px] rounded-full rounded-br-none bg-white w-fit text-sm absolute bottom-[60%] left-[10%] 2xl:left-[23%] contact-badge"
                    style="box-shadow: 0 2.722px 20.412px 0 rgba(0, 122, 255, 0.20);" data-index="0">
                    <p>✅ 24/7 Live Support</p>
                </div>
                <div class="px-3 text-cs-gray-lv-4 py-[6px] rounded-full rounded-tr-none bg-white w-fit text-sm absolute bottom-[30%] left-[5%] 2xl:left-[20%] contact-badge"
                    style="box-shadow: 0 2.722px 20.412px 0 rgba(0, 122, 255, 0.20);" data-index="1">
                    <p>🤝 Personalized Help</p>
                </div>
                <div class="px-3 text-cs-gray-lv-4 py-[6px] rounded-full rounded-bl-none bg-white w-fit text-sm absolute bottom-[50%] right-[3%] 2xl:right-[8%] contact-badge"
                    style="box-shadow: 0 2.722px 20.412px 0 rgba(0, 122, 255, 0.20);" data-index="2">
                    <p>⚡ Fast & Real-Time Assistance</p>
                </div>
                <div class="px-3 text-cs-gray-lv-4 py-[6px] rounded-full rounded-tl-none bg-white w-fit text-sm absolute bottom-[30%] right-[3%] 2xl:right-[8%] contact-badge"
                    style="box-shadow: 0 2.722px 20.412px 0 rgba(0, 122, 255, 0.20);" data-index="3">
                    <p>🛠️ Expert Support Team</p>
                </div>
            </div>
            <div class="flex flex-col gap-[30px] contact-content">
                <div class="flex flex-col gap-3 contact-header">
                    <p class="text-xs lg:text-base font-bold lg:font-normal text-[17px] contact-label">
                        Exceptional Customer Service ✅
                    </p>
                    <h3
                        class="font-monrope text-cs-dark-900 text-xl lg:text-4xl lg:text-[40px] font-[800] contact-title">
                        Don't Hesitate to <span class="text-cs-main-400">Contact Us</span>
                    </h3>
                </div>
                <form id="form-contact-us"
                    class="bg-[#F8F8F8] p-6 sm:p-8 rounded-2xl shadow-lg space-y-4 w-full text-[#414651] contact-form"
                    @submit.prevent="handleContactSubmit">
                    <p class="text-2xl font-bold text-cs-gray-lv-5">
                        Contact Us Anytime 👋
                    </p>
                    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div>
                            <label class="block text-sm mb-1">First name <span class="text-red-500">*</span></label>
                            <input v-model="contactForm.firstName" type="text" placeholder="Enter your first name"
                                :class="['w-full px-3 py-2 border rounded-md', formErrors.firstName ? 'border-red-500' : 'border-gray-300']" />
                            <p v-if="formErrors.firstName" class="text-red-500 text-xs mt-1">{{ formErrors.firstName }}
                            </p>
                        </div>
                        <div>
                            <label class="block text-sm mb-1">Last name <span class="text-red-500">*</span></label>
                            <input v-model="contactForm.lastName" type="text" placeholder="Enter your last name"
                                :class="['w-full px-3 py-2 border rounded-md', formErrors.lastName ? 'border-red-500' : 'border-gray-300']" />
                            <p v-if="formErrors.lastName" class="text-red-500 text-xs mt-1">{{ formErrors.lastName }}
                            </p>
                        </div>
                    </div>

                    <div>
                        <label class="block text-sm mb-1">Email <span class="text-red-500">*</span></label>
                        <div class="relative">
                            <span class="absolute inset-y-0 left-3 flex items-center text-gray-400">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"
                                    fill="none">
                                    <path
                                        d="M1.66699 5.83398L8.47109 10.5969C9.02207 10.9825 9.29756 11.1754 9.59721 11.2501C9.8619 11.3161 10.1387 11.3161 10.4034 11.2501C10.7031 11.1754 10.9786 10.9825 11.5296 10.5969L18.3337 5.83398M5.66699 16.6673H14.3337C15.7338 16.6673 16.4339 16.6673 16.9686 16.3948C17.439 16.1552 17.8215 15.7727 18.0612 15.3023C18.3337 14.7675 18.3337 14.0674 18.3337 12.6673V7.33398C18.3337 5.93385 18.3337 5.23379 18.0612 4.69901C17.8215 4.2286 17.439 3.84615 16.9686 3.60647C16.4339 3.33398 15.7338 3.33398 14.3337 3.33398H5.66699C4.26686 3.33398 3.5668 3.33398 3.03202 3.60647C2.56161 3.84615 2.17916 4.2286 1.93948 4.69901C1.66699 5.23379 1.66699 5.93385 1.66699 7.33398V12.6673C1.66699 14.0674 1.66699 14.7675 1.93948 15.3023C2.17916 15.7727 2.56161 16.1552 3.03202 16.3948C3.5668 16.6673 4.26686 16.6673 5.66699 16.6673Z"
                                        stroke="#717680" stroke-width="1.66667" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                </svg>
                            </span>
                            <input v-model="contactForm.email" type="email" placeholder="Enter your email"
                                :class="['w-full pl-10 px-3 py-2 border rounded-md', formErrors.email ? 'border-red-500' : 'border-gray-300']" />
                        </div>
                        <p v-if="formErrors.email" class="text-red-500 text-xs mt-1">
                            {{ formErrors.email }}
                        </p>
                    </div>

                    <div>
                        <label class="text-sm mb-1 inline-flex gap-[2px]">Question <span class="text-red-500">*</span>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"
                                fill="none">
                                <g clip-path="url(#clip0_6193_40253)">
                                    <path
                                        d="M6.05967 6.00065C6.21641 5.5551 6.52578 5.17939 6.93298 4.94007C7.34018 4.70076 7.81894 4.61328 8.28446 4.69313C8.74998 4.77297 9.17222 5.015 9.47639 5.37634C9.78057 5.73767 9.94705 6.195 9.94634 6.66732C9.94634 8.00065 7.94634 8.66732 7.94634 8.66732M7.99967 11.334H8.00634M14.6663 8.00065C14.6663 11.6826 11.6816 14.6673 7.99967 14.6673C4.31778 14.6673 1.33301 11.6826 1.33301 8.00065C1.33301 4.31875 4.31778 1.33398 7.99967 1.33398C11.6816 1.33398 14.6663 4.31875 14.6663 8.00065Z"
                                        stroke="#A4A7AE" stroke-width="1.33333" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                </g>
                                <defs>
                                    <clipPath id="clip0_6193_40253">
                                        <rect width="16" height="16" fill="white" />
                                    </clipPath>
                                </defs>
                            </svg>
                        </label>
                        <textarea v-model="contactForm.message" placeholder="Write your Message..." rows="4"
                            :class="['w-full px-3 py-2 border rounded-md resize-none', formErrors.message ? 'border-red-500' : 'border-gray-300']">
            </textarea>
                        <p v-if="formErrors.message" class="text-red-500 text-xs mt-1">
                            {{ formErrors.message }}
                        </p>
                    </div>

                    <div class="flex justify-end">
                        <button type="submit"
                            class="font-roboto w-fit text-sm bg-cs-main-500 hover:bg-cs-main-400 flex items-center font-bold text-[#F2F2F3] gap-3 py-3 px-5 rounded-md transition-colors">
                            <span>Send Inquiry</span>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none">
                                <path
                                    d="M16.0052 9.41421L7.39858 18.0208L5.98438 16.6066L14.591 8H7.00519V6H18.0052V17H16.0052V9.41421Z"
                                    fill="white" />
                            </svg>
                        </button>
                    </div>
                </form>
            </div>

        </div>
    </section>
</template>

<script>
// GSAP will be loaded from CDN
let gsap, ScrollTrigger

// Check if GSAP is loaded from CDN
if (typeof window !== 'undefined' && window.gsap) {
    gsap = window.gsap
    ScrollTrigger = window.ScrollTrigger
    gsap.registerPlugin(ScrollTrigger)
} else {
    // Fallback: Load GSAP from CDN if not already loaded
    // eslint-disable-next-line no-unused-vars
    const loadGSAP = () => {
        return new Promise((resolve) => {
            if (window.gsap) {
                resolve()
                return
            }

            const script1 = document.createElement('script')
            script1.src = 'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.2/gsap.min.js'
            script1.onload = () => {
                const script2 = document.createElement('script')
                script2.src = 'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.2/ScrollTrigger.min.js'
                script2.onload = () => {
                    gsap = window.gsap
                    ScrollTrigger = window.ScrollTrigger
                    gsap.registerPlugin(ScrollTrigger)
                    resolve()
                }
                document.head.appendChild(script2)
            }
            document.head.appendChild(script1)
        })
    }
}

const WORK_DATA = [
    {
        image: '/images/landing-work-1.avif',
        title: 'Step 1: The document is uploaded securely.',
        description: 'Select your document and upload it securely over a private connection'
    },
    {
        image: '/images/landing-work-2.avif',
        title: 'Step 2: Signature fields are placed as needed.',
        description: 'Sign by drawing, typing, or uploading your signature.'
    },
    {
        image: '/images/landing-work-3.avif',
        title: 'Step 3: The document is sent for signing.',
        description: "Send the document, invite people to sign, and get alerts when it's signed."
    },
    {
        image: '/images/landing-work-4.avif',
        title: 'Step 4: The final version is prepared for download.',
        description: 'Once signed, download the final document.'
    }
]

const SOLUTION_DATA = [
    {
        image: '/images/landing-solution-1.avif',
        title: 'Effiicient'
    },
    {
        image: '/images/landing-solution-2.avif',
        title: 'Flexible'
    },
    {
        image: '/images/landing-solution-3.avif',
        title: 'Reliable'
    }
]

export default {
    name: 'LandingPageV2',
    props: {
        signupUrl: {
            type: String,
            default: '/sign_up'
        }
    },
    data() {
        return {
            WORK_DATA,
            SOLUTION_DATA,
            contactForm: {
                firstName: '',
                lastName: '',
                email: '',
                message: ''
            },
            formErrors: {
                firstName: '',
                lastName: '',
                email: '',
                message: ''
            }
        }
    },
    watch: {
        'contactForm.firstName'() {
            if (this.formErrors.firstName) {
                this.formErrors.firstName = ''
            }
        },
        'contactForm.lastName'() {
            if (this.formErrors.lastName) {
                this.formErrors.lastName = ''
            }
        },
        'contactForm.email'() {
            if (this.formErrors.email) {
                this.formErrors.email = ''
            }
        },
        'contactForm.message'() {
            if (this.formErrors.message) {
                this.formErrors.message = ''
            }
        }
    },
    async mounted() {
        // Load GSAP if not already available
        if (typeof window !== 'undefined' && !window.gsap) {
            await this.loadGSAP()
        } else if (typeof window !== 'undefined' && window.gsap) {
            gsap = window.gsap
            ScrollTrigger = window.ScrollTrigger
            gsap.registerPlugin(ScrollTrigger)
        }

        // Small delay to ensure DOM is ready
        this.$nextTick(() => {
            setTimeout(() => {
                this.initAnimations()
            }, 100)
        })
    },
    // eslint-disable-next-line vue/no-deprecated-destroyed-lifecycle
    beforeDestroy() {
        // Clean up ScrollTrigger instances
        if (typeof window !== 'undefined' && window.ScrollTrigger) {
            window.ScrollTrigger.getAll().forEach(trigger => trigger.kill())
        }
    },
    methods: {
        async loadGSAP() {
            return new Promise((resolve) => {
                if (window.gsap) {
                    resolve()
                    return
                }

                const script1 = document.createElement('script')
                script1.src = 'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.2/gsap.min.js'
                script1.onload = () => {
                    const script2 = document.createElement('script')
                    script2.src = 'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.2/ScrollTrigger.min.js'
                    script2.onload = () => {
                        gsap = window.gsap
                        ScrollTrigger = window.ScrollTrigger
                        gsap.registerPlugin(ScrollTrigger)
                        resolve()
                    }
                    document.head.appendChild(script2)
                }
                document.head.appendChild(script1)
            })
        },
        handleSignUp() {
            window.location.href = this.signupUrl
        },
        validateForm() {
            this.formErrors = {
                firstName: '',
                lastName: '',
                email: '',
                message: ''
            }

            let isValid = true

            if (!this.contactForm.firstName.trim()) {
                this.formErrors.firstName = 'First name is required'
                isValid = false
            }

            if (!this.contactForm.lastName.trim()) {
                this.formErrors.lastName = 'Last name is required'
                isValid = false
            }

            if (!this.contactForm.email.trim()) {
                this.formErrors.email = 'Email is required'
                isValid = false
            } else {
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
                if (!emailRegex.test(this.contactForm.email)) {
                    this.formErrors.email = 'Please enter a valid email address'
                    isValid = false
                }
            }

            if (!this.contactForm.message.trim()) {
                this.formErrors.message = 'Message is required'
                isValid = false
            } else if (this.contactForm.message.trim().length < 10) {
                this.formErrors.message = 'Message must be at least 10 characters long'
                isValid = false
            }

            return isValid
        },
        handleContactSubmit() {
            if (!this.validateForm()) {
                return
            }

            const subject = encodeURIComponent(`Contact from ${this.contactForm.firstName} ${this.contactForm.lastName}`)
            const body = encodeURIComponent(
                `Name: ${this.contactForm.firstName} ${this.contactForm.lastName}\n` +
                `Email: ${this.contactForm.email}\n\n` +
                `Message:\n${this.contactForm.message}`
            )

            const supportEmail = 'product@antaraetp.com'
            const mailtoLink = `mailto:${supportEmail}?subject=${subject}&body=${body}`

            window.location.href = mailtoLink

            this.contactForm = {
                firstName: '',
                lastName: '',
                email: '',
                message: ''
            }

            alert('Thank you for your inquiry! Your email client should open now.')
        },
        initAnimations() {
            // Ensure GSAP is loaded
            if (!gsap || !ScrollTrigger) {
                console.warn('GSAP not loaded yet')
                return
            }
            // Set initial states for elements
            gsap.set([
                '.hero-title', '.hero-subtitle', '.hero-button',
                '.hero-main-desktop', '.hero-left-desktop', '.hero-right-desktop',
                '.hero-main-mobile', '.hero-left-mobile', '.hero-right-mobile',
                '.work-title', '.work-subtitle', '.work-card',
                '.solution-title', '.solution-subtitle', '.solution-item',
                '.contact-title', '.contact-label', '.contact-form',
                '.contact-main-image', '.contact-badge'
            ], {
                opacity: 0,
                y: 30
            })

            // Hero section animations
            const heroTl = gsap.timeline()
            heroTl
                .to('.hero-title', {
                    opacity: 1,
                    y: 0,
                    duration: 0.8,
                    ease: 'power2.out'
                })
                .to('.hero-subtitle', {
                    opacity: 1,
                    y: 0,
                    duration: 0.6,
                    ease: 'power2.out'
                }, '-=0.4')
                .to('.hero-button', {
                    opacity: 1,
                    y: 0,
                    duration: 0.6,
                    ease: 'back.out(1.7)'
                }, '-=0.3')

            // Hero images animation (desktop)
            gsap.to('.hero-main-desktop', {
                opacity: 1,
                y: 0,
                duration: 1,
                ease: 'power2.out',
                delay: 0.3
            })

            gsap.to('.hero-left-desktop', {
                opacity: 1,
                y: 0,
                x: -20,
                duration: 0.8,
                ease: 'power2.out',
                delay: 0.5
            })

            gsap.to('.hero-right-desktop', {
                opacity: 1,
                y: 0,
                x: 20,
                duration: 0.8,
                ease: 'power2.out',
                delay: 0.7
            })

            // Hero images animation (mobile)
            gsap.to('.hero-main-mobile', {
                opacity: 1,
                y: 0,
                duration: 1,
                ease: 'power2.out',
                delay: 0.3
            })

            gsap.to('.hero-left-mobile', {
                opacity: 1,
                y: 0,
                x: -10,
                duration: 0.8,
                ease: 'power2.out',
                delay: 0.5
            })

            gsap.to('.hero-right-mobile', {
                opacity: 1,
                y: 0,
                x: 10,
                duration: 0.8,
                ease: 'power2.out',
                delay: 0.7
            })

            // Work section header animation
            gsap.timeline({
                scrollTrigger: {
                    trigger: '.work-header',
                    start: 'top 80%',
                    end: 'bottom 20%',
                    toggleActions: 'play none none reverse'
                }
            })
                .to('.work-title', {
                    opacity: 1,
                    y: 0,
                    duration: 0.8,
                    ease: 'power2.out'
                })
                .to('.work-subtitle', {
                    opacity: 1,
                    y: 0,
                    duration: 0.6,
                    ease: 'power2.out'
                }, '-=0.4')

            // Work cards animation with stagger
            gsap.to('.work-card', {
                opacity: 1,
                y: 0,
                duration: 0.8,
                ease: 'power2.out',
                stagger: 0.2,
                scrollTrigger: {
                    trigger: '.work-cards',
                    start: 'top 100%',
                    end: 'bottom 20%',
                    toggleActions: 'play none none reverse'
                }
            })

            // Work card numbers animation
            gsap.fromTo('.work-number',
                {
                    scale: 0,
                    rotation: -45
                },
                {
                    scale: 1,
                    rotation: 0,
                    duration: 0.6,
                    ease: 'back.out(1.7)',
                    stagger: 0.1,
                    scrollTrigger: {
                        trigger: '.work-cards',
                        start: 'top 100%',
                        end: 'bottom 20%',
                        toggleActions: 'play none none reverse'
                    }
                }
            )

            // Solution section animations
            gsap.timeline({
                scrollTrigger: {
                    trigger: '.solution-header',
                    start: 'top 80%',
                    end: 'bottom 20%',
                    toggleActions: 'play none none reverse'
                }
            })
                .to('.solution-title', {
                    opacity: 1,
                    y: 0,
                    duration: 0.8,
                    ease: 'power2.out'
                })
                .to('.solution-subtitle', {
                    opacity: 1,
                    y: 0,
                    duration: 0.6,
                    ease: 'power2.out'
                }, '-=0.4')

            // Solution items animation
            gsap.to('.solution-item', {
                opacity: 1,
                y: 0,
                duration: 0.6,
                ease: 'power2.out',
                stagger: 0.15,
                scrollTrigger: {
                    trigger: '.solution-items',
                    start: 'top 80%',
                    end: 'bottom 20%',
                    toggleActions: 'play none none reverse'
                }
            })

            // Contact section animations
            gsap.timeline({
                scrollTrigger: {
                    trigger: '.contact-header',
                    start: 'top 80%',
                    end: 'bottom 20%',
                    toggleActions: 'play none none reverse'
                }
            })
                .to('.contact-label', {
                    opacity: 1,
                    y: 0,
                    duration: 0.6,
                    ease: 'power2.out'
                })
                .to('.contact-title', {
                    opacity: 1,
                    y: 0,
                    duration: 0.8,
                    ease: 'power2.out'
                }, '-=0.3')

            // Contact form animation
            gsap.to('.contact-form', {
                opacity: 1,
                y: 0,
                duration: 0.8,
                ease: 'power2.out',
                scrollTrigger: {
                    trigger: '.contact-form',
                    start: 'top 80%',
                    end: 'bottom 20%',
                    toggleActions: 'play none none reverse'
                }
            })

            // Contact image and badges animation
            gsap.to('.contact-main-image', {
                opacity: 1,
                y: 0,
                duration: 0.8,
                ease: 'power2.out',
                scrollTrigger: {
                    trigger: '.contact-image',
                    start: 'top 80%',
                    end: 'bottom 20%',
                    toggleActions: 'play none none reverse'
                }
            })

            // Contact badges with stagger and different directions
            gsap.to('.contact-badge', {
                opacity: 1,
                y: 0,
                duration: 0.6,
                ease: 'back.out(1.7)',
                stagger: {
                    amount: 0.8,
                    from: 'random'
                },
                scrollTrigger: {
                    trigger: '.contact-image',
                    start: 'top 70%',
                    end: 'bottom 20%',
                    toggleActions: 'play none none reverse'
                }
            })

            // Add hover animations for interactive elements
            this.addHoverAnimations()
        },
        // eslint-disable-next-line space-before-function-paren
        addHoverAnimations() {
            // Button hover animations

            // Contact badges floating animation
            const contactBadges = document.querySelectorAll('.contact-badge')
            contactBadges.forEach((badge, index) => {
                gsap.to(badge, {
                    y: '+=10',
                    duration: 2 + (index * 0.5),
                    ease: 'power1.inOut',
                    yoyo: true,
                    repeat: -1
                })
            })
        }
    }
}
</script>

<style scoped>
/* Add any additional custom styles if needed */
.hero-button {
    transition: all 0.3s ease;
}

.work-card {
    transition: all 0.3s ease;
}

.solution-item {
    transition: all 0.3s ease;
}

.contact-badge {
    will-change: transform;
}

.border-red-500 {
    border-color: #ef4444 !important;
}

.border-red-500:focus {
    border-color: #ef4444 !important;
    box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.1);
}

.border-gray-300 {
    border-color: #d1d5db;
}

.border-gray-300:focus {
    border-color: #3b82f6;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}
</style>
